import React, { lazy, useContext } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { AuthContext } from "./context/authContext";
import { routes } from "./data/routes";

import PrivateRoute from "./containers/privateRoute";
import PublicRoute from "./containers/publicRoute";
import Login from "./pages/login";
import Contact from "./pages/contact";
import ForgotPassword from "./pages/forgot-password";
import Transactions from "./pages/transactions";
import Accounts from "./pages/accounts";
import ResetPassword from "./pages/reset-password";
import ProductDetails from "./pages/product-details";
import Investments from "./pages/investments";
import Profile from "./pages/profile";
import Products from "./pages/products";
import NotFound from "./pages/notfound";
import ErrorComponent from "./components/error";

export default function Router() {
  const { isAuthenticated } = useContext(AuthContext);

  const router = createBrowserRouter([
    {
      element: isAuthenticated ? (
        <PrivateRoute />
      ) : (
        <Navigate to={routes.LOGIN} />
      ),
      errorElement: <ErrorComponent />,
      children: [
        {
          path: routes.ACCOUNTS,
          element: <Accounts />,
        },
        {
          path: '/',
          element: <Navigate to={routes.INVESTMENTS} />,
        },
        {
          path: routes.INVESTMENTS,
          element: <Investments />,
        },
        {
          path: routes.PROFILE,
          element: <Profile />,
        },
        {
          path: routes.PRODUCTS,
          element: <Products />,
        },
        {
          path: routes.TRANSACTIONS,
          element: <Transactions />,
        },

        {
          path: routes.PROFILE,
          element: <Profile />,
        },
        {
          path: routes.CONTACT,
          element: <Contact />,
        },
        {
          path: routes.PRODUCT_DETAIL,
          element: <ProductDetails />,
        },
      ],
    },
    {
      path: routes.LOGIN,
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: routes.FORGOT_PASSWORD,
      element: (
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      ),
    },
    {
      path: routes.RESET_PASSWORD,
      element: (
        <PublicRoute>
          <ResetPassword />
        </PublicRoute>
      ),
    },

    {
      element: <PublicRoute />,
      children: [
        {
          path: "*",
          element: <NotFound />,
        },
        {
          path: routes.NOT_FOUND,
          element: <NotFound />,
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}
